<div class="search-container-wrapper">
  <div class="search-input-container group">
    <!-- Search Icon -->
    <div class="search-icon-container">
      <svg 
        class="text-slate-400 group-focus-within:text-orange-600"
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="2" 
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>

    <!-- Search Input -->
    <input
      type="text"
      [placeholder]="'Szukaj produktów...' | translate"
      [attr.aria-label]="'Szukaj produktów' | translate"
      class="search-field"
      [formControl]="searchControl"
    />

    <!-- Clear Button (when there's text) -->
    <button 
      *ngIf="searchControl.value"
      type="button" 
      (click)="clearSearch()"
      class="clear-button"
      [attr.aria-label]="'Wyczyść wyszukiwanie' | translate"
    >
      <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>
</div>

<!-- Enhanced Search Results -->
<app-search-results
  *ngIf="searchControl.value !== ''"
  [filteredProducts]="filteredProducts"
  [isSearching]="isSearching"
  [searchError]="searchError"
  [searchQuery]="searchControl.value || ''"
  (productClick)="onProductClick($event)"
  (viewAllResults)="onViewAllResults($event)"
  (browseCategories)="onBrowseCategories()"
  class="search-results-container"
></app-search-results>
